import { isPremiumOption } from './isPremium';

export const generateOrderInfo = (shopifyCiem, variant, currState, result, configID) => {
    const artwork = currState.currentArtwork;
    const shell = currState.currentShell;
    const faceplate = currState.currentFaceplateOption;
    const cable = currState.currentCableOption;
    const customerInfo = currState.finalizeForm;
    const carePlanPrice = currState.iemPrice.carePlan;
    const leftArtwork = isPremiumOption(faceplate.leftOption)
        ? 'None'
        : artwork.leftArtwork.displayName;
    const rightArtwork = isPremiumOption(faceplate.rightOption)
        ? 'None'
        : artwork.rightArtwork.displayName;

    let properties = {};

    properties['Name of User'] = `${customerInfo.userName}`;
    if (customerInfo.userInitials && customerInfo.userInitials.length > 0) {
        properties['User Initials'] = customerInfo.userInitials;
    }
    if (customerInfo.bandName && customerInfo.bandName.length > 0) {
        properties['Band/Church/Company Name'] = customerInfo.bandName;
    }
    properties['Impressions Status'] = customerInfo.impStatus.displayName;
    if (customerInfo.rushStatus) {
        properties['Rush Processing'] =
            customerInfo.rushStatus.displayName + ' ' + customerInfo.rushStatus.price;
    }
    properties['Left Shell'] = shell.leftShell.displayName;
    properties['Right Shell'] = shell.rightShell.displayName;
    const leftFaceplateType = faceplate.leftOption.SK.split('#')[0];
    properties['Left Faceplate'] = `${
        leftFaceplateType.charAt(0).toUpperCase() + leftFaceplateType.slice(1).toLowerCase()
    } ${faceplate.leftOption.displayName}`;
    const rightFaceplateType = faceplate.rightOption.SK.split('#')[0];
    properties['Right Faceplate'] = `${
        rightFaceplateType.charAt(0).toUpperCase() + rightFaceplateType.slice(1).toLowerCase()
    } ${faceplate.rightOption.displayName}`;
    if (Object.keys(result).length === 0) {
        properties['Left Artwork'] = leftArtwork;
        properties['Left Artwork URL'] = artwork.leftArtwork.leftImage;
        properties['Right Artwork'] = rightArtwork;
        properties['Right Artwork URL'] = artwork.rightArtwork.rightImage;
    } else {
        if ('both' in result) {
            properties['Left Artwork'] = 'Custom Artwork';
            properties['Left Artwork URL'] = result.both;
            properties['Right Artwork'] = 'Custom Artwork';
            properties['Right Artwork URL'] = result.both;
        } else {
            if ('left_artwork' in result) {
                properties['Left Artwork'] = 'Custom Artwork';
                properties['Left Artwork URL'] = result.left_artwork;
            } else {
                properties['Left Artwork'] = leftArtwork;
            }
            if ('right_artwork' in result) {
                properties['Right Artwork'] = 'Custom Artwork';
                properties['Right Artwork URL'] = result.right_artwork;
            } else {
                properties['Right Artwork'] = rightArtwork;
            }
        }
    }
    properties['Socket Type'] = cable.activeCableType.split(' ')[0];
    properties['Cable Color'] = cable.activeCableColor;
    properties['Cable Length'] = cable.activeCableLength;
    properties['Case Type'] = '64 Audio Aluminum Case';
    if (customerInfo.isTextOnCase === true) {
        properties['Text On Case'] = 'Yes';
        if (customerInfo.textOnTop && customerInfo.textOnTop.length > 0) {
            properties['Top Text'] = customerInfo.textOnTop;
        }
        if (customerInfo.textOnBottom && customerInfo.textOnBottom.length > 0) {
            properties['Bottom Text'] = customerInfo.textOnBottom;
        }
    } else {
        properties['Text On Case'] = 'No';
    }
    properties['Preview'] = result.preview;
    if (configID) {
        properties['config id'] = configID;
    }
    if (customerInfo.orderNotes && customerInfo.orderNotes.length > 0) {
        properties['Notes'] = customerInfo.orderNotes;
    }
    properties['Care Plan'] =
        customerInfo.carePlanSelected === 'Yes Care Plan Added'
            ? 'Yes Care Plan Added'
            : 'No Care Plan Added';
    if (customerInfo.carePlanSelected === 'Yes Care Plan Added') {
        properties['Care Plan Price'] = parseFloat(carePlanPrice).toFixed(2);
    }
    const orderInfo = {
        items: [
            {
                title: shopifyCiem.title,
                id: variant.id,
                quantity: 1,
                properties: properties
            }
        ]
    };
    return JSON.stringify(orderInfo);
};
